import React from "react";
import { motion } from "framer-motion";

export const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative isolate overflow-hidden bg-loudar-ink py-32 md:py-44"
    >
      {/* Backdrop image */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1800&q=80"
          alt=""
          className="h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-loudar-ink via-loudar-ink/85 to-loudar-ink" />
      </div>

      <div className="container-loudar relative">
        <span className="label-mono">04 — The Mission</span>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
          className="mt-6 max-w-5xl font-display text-4xl uppercase leading-[0.92] tracking-tight text-white sm:text-5xl md:text-7xl lg:text-[112px]"
          data-testid="mission-headline"
        >
          Recognition Shouldn't Depend
          <br />
          On <span className="text-stroke">Who Knows</span>{" "}
          <span className="text-loudar-orange">Your Name.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
          className="mt-12 grid max-w-5xl gap-10 md:grid-cols-2"
        >
          <p className="text-lg leading-relaxed text-white/75 md:text-xl">
            The music industry is built by thousands of people whose work often goes unseen.
            Producers carrying records. Engineers shaping sound. Crews holding tours together.
            Writers behind every chorus. Photographers capturing the moments that become
            iconic.
          </p>
          <p className="text-lg leading-relaxed text-white/75 md:text-xl">
            Loudar exists to professionally represent the people behind the culture — helping
            talent build credibility, showcase verified experience, and create pathways into
            new opportunities. Reputation, finally organised.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="mt-14 flex flex-wrap items-center gap-x-12 gap-y-6 border-t border-white/[0.08] pt-10"
        >
          {[
            ["Hidden contributors", "made visible"],
            ["Verified experience", "made portable"],
            ["Industry pathways", "made navigable"],
          ].map(([a, b], i) => (
            <div key={i} className="max-w-[220px]">
              <div className="font-display text-2xl uppercase tracking-tight text-white">
                {a}
              </div>
              <div className="mt-1 text-sm text-loudar-orange">{b}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Mission;
